import { config } from "../env";
import { Delete, get, patch, post } from "./helpers/http-handler";

export const getTaskComments = (queryRequest: string) =>
  get(`${config.API_URL}/task-comments?${queryRequest}`);

export const getSpecificTaskComment = (id: string) =>
  get(`${config.API_URL}/task-comments/${id}`);

export const addTaskComments = (payload: object) =>
  post(`${config.API_URL}/task-comments`, payload);

export const updateTaskComments = (id: string, payload: object) =>
  patch(`${config.API_URL}/task-comments/${id}`, payload);

export const deleteTaskComments = (id: String) =>
  Delete(`${config.API_URL}/task-comments/${id}`);

export const getSpecificTaskCalenderView = (queryRequest: string) =>
  get(`${config.API_URL}/compliance-task/view/calendar-view?${queryRequest}`);

export const getSpecificLicenseTaskCalenderView = (queryRequest: string) =>
  get(`${config.API_URL}/license-task/view/calendar-view?${queryRequest}`);

export const changeLegalDuedate = (id: string, payload: object) =>
  patch(
    `${config.API_URL}/self-compliance/${id}/change-legal-due-date`,
    payload
  );
